import { ResponsiveUtilities } from './utils';

const mosaicGrid = () => {
  jQuery('.mosaic-item').on('click', function (e) {
    // we don't want the double-tap effect for the links in
    // desktop screens
    ResponsiveUtilities.onDeviceType(['mobile', 'tablet'], function () {
      if (jQuery(this).hasClass('mosaic-hover')) {
        const target = jQuery(this).find('.mosaic-content a')[0];
        if (typeof target !== 'undefined') {
          target.click();
        }
        jQuery(this).removeClass('mosaic-hover');
      } else {
        jQuery(this).addClass('mosaic-hover');
      }
    }, this);
  });
};

export { mosaicGrid };
